import { createEffect, createSignal } from "solid-js";

export function GovernDeliveryNotes(props: {
  workId: string;
  notes: string;
  onSave: (notes: string) => void;
}) {
  const [notes, setNotes] = createSignal(props.notes);
  createEffect(() => {
    props.workId;
    setNotes(props.notes);
  });

  return (
    <section class="govern-plan-section govern-notes-section">
      <header>
        <div>
          <span class="signal-mini-kicker">Delivery context</span>
          <h3>Delivery notes</h3>
        </div>
      </header>
      <label>
        <span>Implementation update, blocker or reviewer note</span>
        <textarea
          rows={4}
          value={notes()}
          onInput={(event) => setNotes(event.currentTarget.value)}
        />
      </label>
      <button
        type="button"
        class="govern-secondary-action"
        disabled={notes().trim() === props.notes.trim()}
        onClick={() => props.onSave(notes().trim())}
      >
        Apply preview note
      </button>
    </section>
  );
}
